
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import { mixins } from "vue-class-component";
import { languageMixin } from "@/mixins/languageMixin";
@Component({
  components: {
    MainHeader,
  },
})
export default class Name extends mixins(languageMixin) {
  private goAuto() {
    this.$router.push("/main/patient/auto");
  }
  private goAdd() {
    this.$router.push("/main/patient/add");
  }
}
